// Helpers
import { oneWeekAgo } from 'helpers/date';
import {
  LinesMatrixIntegrationState,
  LinesMatrixIntegrationTypes,
} from './types';

const { oneDayAgo: startDate, endDate } = oneWeekAgo;

export const INITIAL_STATE: LinesMatrixIntegrationState = {
  lineMatrixIntegrationData: {
    id: '',
    value: 0,
    valueType: 0,
    fareType: 0,
    time: 0,
    timeMin: 0,
    status: 0,
    startTime: 0,
    endTime: 0,
    quantity: 1,
    createdAt: '',
    updatedAt: '',
    startId: '',
    endId: '',
    transportOperatorId: '',
    lineId: '',
  },
  linesMatrixIntegrationList: [],
  createLineMatrixIntegration: [],
  selectedLines: [],
  selectedStartDate: new Date(startDate),
  selectedEndDate: new Date(endDate),
  totalCount: 0,
  error: false,
  loading: false,
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

// List Line Matrix Integration
const listLinesMatrixIntegrationRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  linesList: INITIAL_STATE.linesMatrixIntegrationList,
});

const listLinesMatrixIntegrationSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  linesMatrixIntegrationList: action.payload.linesMatrixIntegrationList,
  totalCount: action.payload.totalCount,
});

const listLinesMatrixIntegrationFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  linesMatrixIntegrationList: INITIAL_STATE.linesMatrixIntegrationList,
});

// Get Line Matrix Integration
const getLineMatrixIntegrationRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  lineMatrixIntegrationData: INITIAL_STATE.lineMatrixIntegrationData,
});

const getLineMatrixIntegrationSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  lineMatrixIntegrationData: action.payload.lineMatrixIntegrationData,
});

const getLineMatrixIntegrationFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  lineMatrixIntegrationData: INITIAL_STATE.lineMatrixIntegrationData,
});

// Create Line Matrix Integration (Local)
const createLineMatrixIntegration = (state: any, action: any) => ({
  ...state,
  createLineMatrixIntegration: action.payload.createLineMatrixIntegration,
});

// Create Line Matrix Integration
const createLineMatrixIntegrationRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  lineMatrixIntegrationData: INITIAL_STATE.lineMatrixIntegrationData,
});

const createLineMatrixIntegrationSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  lineMatrixIntegrationData: action.payload.lineMatrixIntegrationData,
});

const createLineMatrixIntegrationFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  lineMatrixIntegrationData: INITIAL_STATE.lineMatrixIntegrationData,
});

// Update Line Matrix Integration
const updateLineMatrixIntegrationRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateLineMatrixIntegrationSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const updateLineMatrixIntegrationFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Line Matrix Integration
const deleteLineMatrixIntegrationRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteLineMatrixIntegrationSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteLineMatrixIntegrationFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// SET SELECTED LINES
const selectedLines = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

/* eslint-disable max-len */
const reducer = createReducer(INITIAL_STATE, {
  [LinesMatrixIntegrationTypes.LIST_LINES_MATRIX_INTEGRATION_REQUEST]: listLinesMatrixIntegrationRequest,
  [LinesMatrixIntegrationTypes.LIST_LINES_MATRIX_INTEGRATION_SUCCESS]: listLinesMatrixIntegrationSuccess,
  [LinesMatrixIntegrationTypes.LIST_LINES_MATRIX_INTEGRATION_FAILURE]: listLinesMatrixIntegrationFailure,

  [LinesMatrixIntegrationTypes.GET_LINE_MATRIX_INTEGRATION_REQUEST]: getLineMatrixIntegrationRequest,
  [LinesMatrixIntegrationTypes.GET_LINE_MATRIX_INTEGRATION_SUCCESS]: getLineMatrixIntegrationSuccess,
  [LinesMatrixIntegrationTypes.GET_LINE_MATRIX_INTEGRATION_FAILURE]: getLineMatrixIntegrationFailure,

  [LinesMatrixIntegrationTypes.CREATE_LINE_MATRIX_INTEGRATION_REQUEST]: createLineMatrixIntegrationRequest,
  [LinesMatrixIntegrationTypes.CREATE_LINE_MATRIX_INTEGRATION_SUCCESS]: createLineMatrixIntegrationSuccess,
  [LinesMatrixIntegrationTypes.CREATE_LINE_MATRIX_INTEGRATION_FAILURE]: createLineMatrixIntegrationFailure,

  [LinesMatrixIntegrationTypes.CREATE_LINE_MATRIX_INTEGRATION]: createLineMatrixIntegration,

  [LinesMatrixIntegrationTypes.UPDATE_LINE_MATRIX_INTEGRATION_REQUEST]: updateLineMatrixIntegrationRequest,
  [LinesMatrixIntegrationTypes.UPDATE_LINE_MATRIX_INTEGRATION_SUCCESS]: updateLineMatrixIntegrationSuccess,
  [LinesMatrixIntegrationTypes.UPDATE_LINE_MATRIX_INTEGRATION_FAILURE]: updateLineMatrixIntegrationFailure,

  [LinesMatrixIntegrationTypes.DELETE_LINE_MATRIX_INTEGRATION_REQUEST]: deleteLineMatrixIntegrationRequest,
  [LinesMatrixIntegrationTypes.DELETE_LINE_MATRIX_INTEGRATION_SUCCESS]: deleteLineMatrixIntegrationSuccess,
  [LinesMatrixIntegrationTypes.DELETE_LINE_MATRIX_INTEGRATION_FAILURE]: deleteLineMatrixIntegrationFailure,

  [LinesMatrixIntegrationTypes.SELECTED_LINES]: selectedLines,
});

export default reducer;
